<template>
  <div class="category-block">
    <div class="section-title">■ DESIGN AREA</div>
    <div class="component-buttons">
      <button 
        v-for="comp in currentComponents" 
        :key="comp"
        :class="[
          'comp-btn', 
          { 'active': comp === currentSelectedPart },
          { 'whole-btn': comp === 'whole' }
        ]"
        @click="selectPart(comp)"
      >
        {{ comp.charAt(0).toUpperCase() + comp.slice(1).toLowerCase() }}
      </button>
    </div>
  </div>
</template>

<script>
import { useDesignStore } from '@/stores/designStore'
import { onBeforeUnmount } from 'vue'

export default {
  name: 'PartSelector',
  data() {
    return {
      currentComponents: [],
      currentSelectedPart: 'front',
      compDefinitions: {
        'Short Sleeve': ['whole', 'front', 'back', 'collar', 'left sleeve', 'right sleeve', 'left side', 'right side', 'pocket'],
        'Long Sleeve': ['whole', 'front', 'back', 'collar', 'left sleeve', 'right sleeve', 'left side', 'right side', 'pocket'],
        'Cycling Vest': ['whole', 'front', 'back', 'collar', 'left side', 'right side', 'pocket'],
        'Mx Jersey': ['whole', 'front', 'back', 'collar', 'left sleeve', 'right sleeve'],
        'Hoodie': ['whole', 'front', 'back', 'hood', 'left sleeve', 'right sleeve', 'pocket'],
        'T-shirt': ['whole', 'front', 'back', 'collar', 'left sleeve', 'right sleeve'],
        'Baseball Jersey': ['whole', 'front', 'back', 'left sleeve', 'right sleeve']
      }
    }
  },
  mounted() {
    const store = useDesignStore()
    this.updateComponents(store.currentGarment)
    this.currentSelectedPart = store.currentSelectedPart

    this._unsubscribe = store.$subscribe((mutation, state) => {
      this.updateComponents(state.currentGarment)
      this.currentSelectedPart = state.currentSelectedPart
    })
  },
  beforeUnmount() {
    if (this._unsubscribe) {
      this._unsubscribe()
    }
  },
  methods: {
    updateComponents(garmentType) {
      this.currentComponents = this.compDefinitions[garmentType] || this.compDefinitions['Short Sleeve']
    },
    selectPart(part) {
      this.currentSelectedPart = part
      this.$emit('part-clicked', part)
    }
  }
}
</script>

<style scoped>
.component-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.3rem;
}
.comp-btn {
  background: #ffffff;
  border: 1px solid #d0d0d0;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 500;
  color: #000000;
  cursor: pointer;
  transition: all 0.2s;
}
.comp-btn.active {
  background: #f0f0f0;
  border-color: #3b82f6;
}
/* whole 按钮特殊样式 */
.comp-btn.whole-btn {
  font-weight: 700;
  border-color: #d0d0d0;
}
.comp-btn.whole-btn.active {
  border-color: #ef4444 !important;
  background: #f0f0f0;
  color: #ef4444 !important;  /* 选中时文字变红色 */
}
.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #072a47;
  margin-bottom: 0.3rem;
  padding-left: 4px;
}
.category-block {
  margin-bottom: 0.6rem;
  border: none;
  position: relative;
}
@media (min-width: 851px) {
  .comp-btn {
    font-size: 0.85rem;
    padding: 0.3rem 0.6rem;
    min-width: auto;
    width: auto;
  }
}
@media (max-width: 850px) {
  .component-buttons {
    margin-top: 0;
    gap: 0.15rem;
  }
  .comp-btn {
    padding: 0.15rem 0.5rem;
    font-size: 0.85rem;
    border-radius: 4px;
  }
}
</style>